module.exports = __webpack_public_path__ + "static/img/06022D_X_04_20170725_fit.09a14b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06022D_X_04_20170725_fit.png
// module id = Fn3k
// module chunks = 0